export const propertyReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_PROPERTY_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        // properties: null,
      };
    case "GET_PROPERTY_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        properties: action.payload,
      };
    case "GET_PROPERTY_LIST_FAILED":
      return {
        ...state,
        loading: false,
        properties: action.payload,
      };
    case "GET_PROPERTY_REQUEST":
      return {
        ...state,
        loading: true,
        // property: null,
      };
    case "GET_PROPERTY_SUCCESS":
      return {
        ...state,
        loading: false,
        property: action.payload,
      };
    case "GET_PROPERTY_FAILED":
      return {
        ...state,
        loading: false,
        property: action.payload,
      };
    case "GET_SUBCATEGORY_REQUEST":
      return {
        ...state,
        loading: true,
        // subcategories: null,
      };
    case "GET_SUBCATEGORY_SUCCESS":
      return {
        ...state,
        loading: false,
        subcategories: action.payload,
      };
    case "GET_SUBCATEGORY_FAILED":
      return {
        ...state,
        loading: false,
        subcategories: action.payload,
      };
    case "UPDATE_REWARD_POINTS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "UPDATE_REWARD_POINTS_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "UPDATE_REWARD_POINTS_FAILED":
      return {
        ...state,
        loading: false,
      };

    case "GET_CITY_TOTAL_PRICE_REQUEST":
      return {
        ...state,
        cityTotalPriceLoading: true,
        // cityTotalPrice: null,
        cityTotalPriceError: null,
      };
    case "GET_CITY_TOTAL_PRICE_SUCCESS":
      return {
        ...state,
        cityTotalPriceLoading: false,
        cityTotalPrice: action.payload.data,
        // cityTotalPriceError: null,
      };
    case "GET_CITY_TOTAL_PRICE_FAILED":
      return {
        ...state,
        cityTotalPriceLoading: false,
        // cityTotalPrice: null,
        cityTotalPriceError: action.payload,
      };

    case "ADD_ADMIN_MARGIN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_ADMIN_MARGIN_SUCCESS":
      return {
        ...state,
        loading: false,
        adminMarginAdded: true,
      };
    case "ADD_ADMIN_MARGIN_FAILED":
      return {
        ...state,
        loading: false,
        adminMarginError: action.payload,
      };

    case "UPDATE_ADMIN_MARGIN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "UPDATE_ADMIN_MARGIN_SUCCESS":
      return {
        ...state,
        loading: false,
        adminMarginUpdated: true,
      };
    case "UPDATE_ADMIN_MARGIN_FAILED":
      return {
        ...state,
        loading: false,
        adminMarginError: action.payload,
      };

    // NEW MARGIN RATIO CASES
    case "ADD_MARGIN_RATIO_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_MARGIN_RATIO_SUCCESS":
      return {
        ...state,
        loading: false,
        marginRatioAdded: true,
      };
    case "ADD_MARGIN_RATIO_FAILED":
      return {
        ...state,
        loading: false,
        marginRatioError: action.payload,
      };

    case "UPDATE_MARGIN_RATIO_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "UPDATE_MARGIN_RATIO_SUCCESS":
      return {
        ...state,
        loading: false,
        marginRatioUpdated: true,
      };
    case "UPDATE_MARGIN_RATIO_FAILED":
      return {
        ...state,
        loading: false,
        marginRatioError: action.payload,
      };

    case "GET_MARGIN_HISTORY_REQUEST":
      return {
        ...state,
        loading: true
      };

    case "GET_MARGIN_HISTORY_SUCCESS":
      return {
        ...state,
        loading: false,
        marginHistory: action.payload.data
      };

    case "GET_MARGIN_HISTORY_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case "UPDATE_PROPERTY_PRICE_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "UPDATE_PROPERTY_PRICE_SUCCESS":
      return {
        ...state,
        loading: false,
        propertyPriceUpdated: true,
      };
    case "UPDATE_PROPERTY_PRICE_FAILED":
      return {
        ...state,
        loading: false,
        propertyPriceError: action.payload,
      };

    default:
      return state;
  }
};
